import React, { useCallback, useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import styles from './css/UpcomingShow.module.css';

import callApi from '../../utils/callApi';
import { SCHEDULED_SHOWS_URL } from '../../constants/apiUrls/apiUrls';


function UpcomingShow(props) {
  const { anchorId } = props;
  const [dateOfNextShow, setDateOfNextShow] = useState('');

  const setDateOfUpcomingShow = useCallback(() => {
    const url = SCHEDULED_SHOWS_URL.replace('{temptationId}', parseInt(anchorId, 10));
    callApi(url, 'get', { page: 0 }).then((res) => {
      if (!res.data.calendarShows?.[0]?.scheduledAt) {
        setDateOfNextShow('');
      } else {
        const date = moment(res.data.calendarShows?.[0]?.scheduledAt);
        const formattedDate = date.format('MMM D, hA');
        setDateOfNextShow(formattedDate);
      }
    }).catch(() => setDateOfNextShow(''));
  }, [anchorId]);

  useEffect(() => {
    setDateOfUpcomingShow();
  }, []);

  const nextShow = useMemo(() => {
    if (dateOfNextShow.length) {
      return dateOfNextShow;
    }

    return 'To Be Announced';
  })

  return (
    <h3 className={styles.upcomingShow}>
      <b>Next Show:</b> {nextShow}
    </h3>
  );
}

export default UpcomingShow;

UpcomingShow.propTypes = { anchorId: PropTypes.string.isRequired };
